import { SecurityService } from 'app/services/security/security.service';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-nuevo-empresa',
  templateUrl: './nuevo-empresa.component.html',
  styleUrls: ['./nuevo-empresa.component.scss'],
  providers: [MessagesTitles, MessagesStatus, DatePipe, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class NuevoEmpresaComponent {

  Label_Proveedor = environment.LABEL_PROVEEDOR;
  Label_Proveedores = environment.LABEL_PROVEEDORES;
  Label_Adquirente = environment.LABEL_ADQUIRENTE;
  Label_Adquirentes = environment.LABEL_ADQUIRENTES;
  datos = {
    Num_Doc_Identificacion: "",
    Tipo_Doc_Identificacion: "R"
  }

  loading: boolean = false;
  personaJuridica;
  titulo: string;
  editar: boolean = false;
  form: FormGroup;
  user: any;
  ipAddress: any;

  constructor(private securityService: SecurityService, private riesgoService: RiesgoService, private router: Router, private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.form = new FormGroup({
      Ruc: new FormControl({ value: "", disabled: false }, [Validators.required, Validators.pattern("[0-9]{11}$")]),
      Empresa: new FormControl('', [Validators.required]),
      Direccion: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Telefono: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Anexo: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Movil: new FormControl({ value: "", disabled: false }, [Validators.required]),
      TipoEmpresa: new FormControl({ value: "50" }, [Validators.required]),
      Pais: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Localidad1: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Localidad2: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Localidad3: new FormControl({ value: "", disabled: false }, [Validators.required]),
      CodigoUbicacion: new FormControl('',),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    });
    this.titulo = "Registro de Empresa";
  }

  validarNumDocumento() {
    if (this.form.controls['Ruc'].invalid) {
      Swal.fire({
        title: '¡¡Advertencia!',
        text: 'N° de identificación invalido',
        type: 'info',
        allowOutsideClick: true,
        heightAuto: false
      });
    } else {
      this.loading = true;
      this.riesgoService.RiesgoRUCTotal(this.datos).subscribe(res => {
        if (res['message']) {
          this.loading = false;
          Swal.fire({
            title: '¡¡Advertencia!',
            text: 'El numero de identificación no existe.',
            type: 'warning',
            allowOutsideClick: true,
            heightAuto: false
          });
        } else {
          this.personaJuridica = res;
          this.cargarCampos();
          this.loading = false;
        }
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "RIESGO no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
    }
  }

  cargarCampos() {

    this.crearFormulario();
    this.form.controls['Ruc'].setValue(this.personaJuridica.Documento);
    this.form.controls['Empresa'].setValue(this.personaJuridica.RazonSocial);
    this.form.controls['Direccion'].setValue(this.personaJuridica.NomVia + " - " + this.personaJuridica.NumPredio);
    this.form.controls['Pais'].setValue(this.personaJuridica.Pais);
    this.form.controls['Localidad1'].setValue(this.personaJuridica.Departamento);
    this.form.controls['Localidad2'].setValue(this.personaJuridica.Provincia);
    this.form.controls['Localidad3'].setValue(this.personaJuridica.Distrito);
    this.form.controls['CodigoUbicacion'].setValue(this.personaJuridica.UBIGEO);
    this.form.controls['Pais'].setValue('Perú');
  }

  crearFormulario() {
    this.form = new FormGroup({
      Ruc: new FormControl({ value: "", disabled: false }, [Validators.required, Validators.pattern("[0-9]{11}$")]),
      Empresa: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Direccion: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Telefono: new FormControl({ value: "", disabled: false }),
      Anexo: new FormControl({ value: "", disabled: false }),
      Movil: new FormControl({ value: "", disabled: false }),
      TipoEmpresa: new FormControl('50', [Validators.required]),
      Pais: new FormControl('Perú', [Validators.required]),
      Localidad1: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Localidad2: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Localidad3: new FormControl({ value: "", disabled: true }, [Validators.required]),
      CodigoUbicacion: new FormControl('',),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    });
  }

  guardarCambios() {
    if (this.form.invalid) {
      Swal.fire({
        title: '¡Incomplete form!',
        text: 'Por favor completar todos los campos requeridos del formulario.',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }

    Swal.fire({
      title: '¡Espere por favor!',
      text: 'Estamos guardando la información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.securityService.registrarEmpresa(this.form.getRawValue())
      .subscribe(() => {

        this.loading = false;
        Swal.fire({
          title: "¡Éxito!",
          text: this.Label_Proveedor + 'Proveedor guardado correctamente.',
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(resp => {
          if (resp.value) {
            this.router.navigate(['/empresaSeg/listado']);
          }
        })
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
      }
      );
  }
}